document.addEventListener('DOMContentLoaded', function() {
  // --- Utility: Update URL params without reloading ---
  function updateUrlParams(params) {
    console.log('Updating URL params from component-product-url-sync.js 39', params);
    const url = new URL(window.location);
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null) {
        url.searchParams.set(key, encodeURIComponent(value).replace(/%20/g, '+'));
      } else {
        url.searchParams.delete(key);
      }
    });
    console.log('URL from component-product-url-sync.js 42', url);
    window.history.replaceState({}, '', url);
  }

  function isVisible(el) {
    if (!el) return false;

    while (el) {
      const style = getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
        return false;
      }
      el = el.parentElement;
    }
    return true;
  
  }

  function isIsraelMarket() {
    const countryCode = typeof KROWN !== 'undefined' && KROWN.settings
      ? KROWN.settings.current_country_code
      : '';

    return String(countryCode || '').trim().toUpperCase() === 'IL' || document.body.classList.contains('store-IL');
  }

  function optionMatchesServings(option, servings) {
    const attrValue = option.getAttribute('data-shipment-attribute-value');
    return attrValue
      ? attrValue.includes(servings)
      : option.value.includes(servings);
  }

  function isActiveSelectOption(select, option) {
    return !!option && option.parentElement === select && !option.disabled;
  }

  function isPureOtsOption(option) {
    return (option.getAttribute('data-payment-type') || '') === ''
      && (option.getAttribute('data-subscription') || '') === '';
  }

  function findServingsOption(select, servings, params) {
    const activeMatches = Array.from(select.options).filter(
      (option) => isActiveSelectOption(select, option) && optionMatchesServings(option, servings)
    );

    if (
      isIsraelMarket() &&
      params.get('subscription') === 'false' &&
      params.get('payment_type') === 'normal'
    ) {
      return activeMatches.find(isPureOtsOption) || null;
    }

    if (activeMatches.length) {
      return activeMatches[0];
    }

    return Array.from(select.options).find((option) => optionMatchesServings(option, servings)) || null;
  }

  function applyServingsFromUrl(params) {
    const select = document.querySelector('.product-variant-shipment-amount');
    const servingsRaw = params.get('servings');
    if (!select || !servingsRaw) return;

    const servings = servingsRaw.replace(/\+/g, ' ');
    const matchingOption = findServingsOption(select, servings, params);

    if (matchingOption) {
      select.value = matchingOption.value;
      select.dispatchEvent(new Event('change', { bubbles: true, detail: { serving: true } }));
      return;
    }

    if (params.get('subscription') !== 'true') {
      document.dispatchEvent(new CustomEvent('variant-picker:check-subscription', { bubbles: true }));
    }
  }

  function shouldDeferServingsRestore(params) {
    return isIsraelMarket()
      && params.get('subscription') === 'false'
      && params.has('payment_type')
      && params.has('servings');
  }

  // --- Get current selections from the form ---
  function getCurrentSelections() {
    console.log('Getting current selections from component-product-url-sync.js 38');
    const values = {
      subscription: null,
      servings: null,
      payment_type: null,
    };
  
    // Subscription
    const purchaseRadios = document.querySelectorAll('input[name^="type_of_subscription_"]');
    if (purchaseRadios.length === 1 && isVisible(purchaseRadios[0])) {
      // If only one option, use its value
      values.subscription = purchaseRadios[0].value === 'subscription' ? 'true' : 'false';
    } else {
      // Otherwise use checked radio value
      const purchaseRadio = document.querySelector('input[name^="type_of_subscription_"]:checked');
      if (purchaseRadio && isVisible(purchaseRadio)) {
        values.subscription = purchaseRadio.value === 'subscription' ? 'true' : 'false';
      }
    }
  
    // Servings
    const shipmentSelect = document.querySelector('.product-variant-shipment-amount');
    if (shipmentSelect && shipmentSelect.selectedIndex >= 0) {
      const selectedOption = shipmentSelect.options[shipmentSelect.selectedIndex];
      if (selectedOption) {
        const shipmentAttributeValue = selectedOption.getAttribute('data-shipment-attribute-value');
        if (shipmentAttributeValue) {
          values.servings = shipmentAttributeValue;
        } else if (selectedOption.value) {
          values.servings = selectedOption.value;
        }
      }
    }
  
    // Payment Type — read from whichever payment type container is visible (subscription or OTS)
    const paymentTypeSelect = document.querySelector('.product-payment-type--select');
    const otsPaymentTypeSelect = document.querySelector('.product-ots-payment-type--select');
    if (isVisible(paymentTypeSelect)) {
      const checkedRadio = paymentTypeSelect.querySelector('input[type="radio"].product-payment-type-radio:checked');
      if (checkedRadio) {
        console.log('Checked radio from component-product-url-sync.js 74', checkedRadio);
        const paymentType = checkedRadio.getAttribute('data-payment-type');
        console.log('Payment type from component-product-url-sync.js 76', paymentType);
        if (paymentType) values.payment_type = paymentType;
      }
    } else if (isVisible(otsPaymentTypeSelect)) {
      const checkedOtsRadio = otsPaymentTypeSelect.querySelector('input[type="radio"].product-ots-payment-type-radio:checked');
      if (checkedOtsRadio) {
        const otsPaymentType = checkedOtsRadio.getAttribute('data-payment-type');
        if (otsPaymentType) values.payment_type = otsPaymentType;
      }
    } else {
      console.log('Payment type container not visible from component-product-url-sync.js 78');
    }
    
    return values;
  }
  

  // --- Set form selections from URL params --- 
  function setSelectionsFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const paramHandlers = {
      subscription: () => {
        const value = params.get('subscription') === 'true' ? 'subscription' : 'one-time';
        const radio = document.querySelector(`input[name^="type_of_subscription_"][value="${value}"]`);
        if (radio){
          radio.checked = true;
          const changeEvent = new Event('change', {bubbles: true});
          radio.dispatchEvent(changeEvent);
        } 
      },
      servings: () => {
        if (shouldDeferServingsRestore(params)) return;

        setTimeout(() => applyServingsFromUrl(params), 200);
      },
      payment_type: () => {
        const paymentType = params.get('payment_type');
        if (!paymentType) return;
        // Delay to ensure payment type is restored after updatePricesInitial() has run (which fires at ~2ms)
        setTimeout(() => {
          const restorePaymentTypeRadio = (containerSelector, radioSelector) => {
            const container = document.querySelector(containerSelector);
            if (!container) return;

            const radio = container.querySelector(`input[type="radio"].${radioSelector}[data-payment-type="${paymentType}"]`);
            if (radio) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          };

          if (isIsraelMarket() && params.has('subscription')) {
            const subscriptionParam = params.get('subscription');

            if (subscriptionParam === 'true') {
              restorePaymentTypeRadio('.product-payment-type--select', 'product-payment-type-radio');
              return;
            }

            if (subscriptionParam === 'false') {
              restorePaymentTypeRadio('.product-ots-payment-type--select', 'product-ots-payment-type-radio');
              if (params.has('servings')) {
                setTimeout(() => applyServingsFromUrl(params), 100);
              }
              return;
            }
          }

          // Restore subscription payment type
          const select = document.querySelector('.product-payment-type--select');
          if (select) {
            const radio = select.querySelector(`input[type="radio"].product-payment-type-radio[data-payment-type="${paymentType}"]`);
            if (radio) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
          // Restore OTS payment type
          const otsSelect = document.querySelector('.product-ots-payment-type--select');
          if (otsSelect) {
            const otsRadio = otsSelect.querySelector(`input[type="radio"].product-ots-payment-type-radio[data-payment-type="${paymentType}"]`);
            if (otsRadio) {
              otsRadio.checked = true;
              otsRadio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        }, 50);
      }
    };

    Object.keys(paramHandlers).forEach(param => {
      if (params.has(param)) paramHandlers[param]();
    });
  }

  // --- Listen for changes on all relevant inputs ---
  // Block URL updates during page initialization to prevent race conditions
  // (e.g. updatePaymentTypeRadioVisibility resetting radio before correct serving loads)
  let pageInitialized = false;
  setTimeout(() => { pageInitialized = true; }, 300);

  function addListeners() {
    const selectors = {
      'input[name^="type_of_subscription_"]': true,
      '.product-variant-shipment-amount': false,
      '.product-payment-type--select': false,
      '.product-ots-payment-type--select': false,
    };

    for (const [selector, multiple] of Object.entries(selectors)) {
      const elements = multiple ?
        document.querySelectorAll(selector) :
        [document.querySelector(selector)].filter(Boolean);

      elements.forEach(el => {
        // Special handling for payment type radio buttons
        if (selector === '.product-payment-type--select') {
          const radioButtons = el.querySelectorAll('input[type="radio"].product-payment-type-radio');
          console.log('Radio buttons from component-product-url-sync.js 159', radioButtons);
          radioButtons.forEach(radio => {
            console.log('Radio from component-product-url-sync.js 161', radio);
            radio.addEventListener('change', () => { if (pageInitialized) updateUrlParams(getCurrentSelections()); });
          });
        } else if (selector === '.product-ots-payment-type--select') {
          const otsRadioButtons = el.querySelectorAll('input[type="radio"].product-ots-payment-type-radio');
          otsRadioButtons.forEach(radio => {
            radio.addEventListener('change', () => { if (pageInitialized) updateUrlParams(getCurrentSelections()); });
          });
        } else {
          console.log('Element from component-product-url-sync.js 169', el);
          el.addEventListener('change', () => {
            console.log('Element change event from component-product-url-sync.js 171');
            if (pageInitialized) updateUrlParams(getCurrentSelections());
          });
        }
      });
    }
  }

  // Initialize
  setSelectionsFromUrl();
  addListeners();
  // Do NOT call updateUrlParams on initial load — the cascade in VariantPicker may have
  // clicked the subscription radio before DOMContentLoaded, causing getCurrentSelections()
  // to return subscription=true and pollute the URL. This makes initializeDropdownPlacement()
  // in main-product.liquid read ?subscription=true and override the admin default purchase type.
  // URL params are updated only when the user changes a selection (via addListeners above).
});